import { EAppId } from "@timeedit/types/lib/enums";
import type { EAppEnv } from "@timeedit/types/lib/enums/appEnv.enum";
import type { ITEToken, TOrganization } from "@timeedit/types/lib/types";
import { ThemeWrapper } from "@timeedit/ui-components/components/ThemeWrapper/ThemeWrapper";
import { TopBarContent } from "@timeedit/ui-components/components/Topbar/TopbarContent";
import { useEffect, useState } from "react";
import { angularize } from "react-in-angularjs";

type TEnvironment = {
  environment: EAppEnv;
};

async function fetchData(url: string) {
  const response = await fetch(url);
  return response.json();
}

const TEProductSelector = () => {
  const [environment, setEnvironment] = useState<TEnvironment>();
  const [organization, setOrganization] = useState<TOrganization>();

  useEffect(function loadProductSelectorData() {
    function logFailure(error: unknown) {
      console.error("Failed to load the product selector data", error);
    }

    fetchData("/api/actuator/environment").then(setEnvironment).catch(logFailure);
    fetchData("/api/organization").then(setOrganization).catch(logFailure);
  }, []);

  return environment && organization ? (
    // ThemeWrapper supplies the antd theme and token sync this component needs.
    <ThemeWrapper defaultComponentSize="middle">
      <div className="product-selector__wrapper">
        <TopBarContent.ProductSelector
          appEnv={environment.environment}
          currentProduct={EAppId.TE_EVALUATION}
          organization={organization}
          user={
            {
              // Only scopes are used inside UI-components :shrug:
              scopes: organization.enabledProducts
            } as ITEToken
          }
        />
      </div>
    </ThemeWrapper>
  ) : null;
};

angularize(TEProductSelector, "productSelectorAngularized", angular.module("diceApp"));

export default TEProductSelector;
